module.exports = __webpack_public_path__ + "img/play.2baa8fe4.png";